import React from 'react'
import Forms from '../components/Forms'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

export default function Banner() {
  return (
    <>
      <section className="banner">
    <div className="container-fluid">
        <div className="row">
            <div className="col-md-12 p-0">
                <div className="sub-banner">
                    <div id="carouselFade" className="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-pause="false" data-bs-interval="3000">
                        <div className="carousel-inner">
                          <div className="carousel-item active">
                            <img src="assets/img/banner1.jpg" className="d-block w-100" alt="..." />
                            <div className="carousel-caption">
                                <h1>Leh Ladakh Expedition Experiences</h1>
                                <p>Embark on an adventure into the breathtaking realm of the Himalayan wonderland.</p>
                              </div>
                          </div>
                          <div className="carousel-item">
                            <img src="assets/img/banner2.jpg" className="d-block w-100" alt="..." />
                            <div className="carousel-caption">
                                <h1>Dubai Expedition Experiences</h1>
                                <p>Embark on an adventure into the breathtaking realm of the Himalayan wonderland.</p>
                              </div>
                          </div>
                          <div className="carousel-item">
                            <img src="assets/img/banner3.jpg" className="d-block w-100" alt="..." />
                            <div className="carousel-caption">
                                <h1>Maldives Expedition Experiences</h1>
                                <p>Embark on an adventure into the breathtaking realm of the Himalayan wonderland.</p>
                              </div>
                          </div>  
                        </div>
                        <button className="carousel-control-prev" type="button" data-bs-target="#carouselFade" data-bs-slide="prev">
                          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                          <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#carouselFade" data-bs-slide="next">
                          <span className="carousel-control-next-icon" aria-hidden="true"></span>
                          <span className="visually-hidden">Next</span>
                        </button>
                    </div>
                    <div className="queryForm">
                    
                        <h2>Any Query? <strong>Call Now</strong></h2>
                    <Forms submitBtnName="Submit" formsource="Banner"/>
                </div>
                </div>
                
            </div>
        </div>
    </div>
</section>
    </>
  )
}
